import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/'
import { ENTITIES, ACTIONS } from '@/utils/constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      component: () =>
        import(/* webpackChunkName: 'layout' */ '../views/Layout'),
      path: '/',
      children: [
        {
          component: () =>
            import(/* webpackChunkName: 'dashboard' */ '../views/Dashboard'),
          path: '',
          name: 'dashboard'
        },
        {
          component: () =>
            import(/* webpackChunkName: 'invoices' */ '../views/Invoices'),
          path: '/invoices',
          name: 'invoices'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'invoicesAdd' */ '..//views/Invoices/Add'
            ),
          path: '/invoices/add/:id?/:value?',
          name: 'invoicesAdd',
          beforeEnter: (to, from, next) => {
            const toDashboard = !store.getters.hasActionPermission(
              ENTITIES.INVOICE,
              ACTIONS.CREATE
            )
            if (toDashboard) {
              next('/')
            } else {
              next()
            }
          }
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'invoicesEsign' */ '..//views/Invoices/Esign'
            ),
          path: '/invoices/esign',
          name: 'invoicesEsign'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'singleInvoice' */ '../views/Invoices/SingleInvoice'
            ),
          path: '/invoices/:id',
          name: 'invoicesSingle'
        },
        {
          component: () =>
            import(/* webpackChunkName: 'transactions' */ '../views/Supplier'),
          path: '/suppliers',
          name: 'suppliers'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'singleSupplier' */ '../views/Supplier/ViewSupplier'
            ),
          path: '/supplier/view/:id',
          name: 'singleSupplier'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'addSupplier' */ '../views/Supplier/AddSupplier'
            ),
          path: '/supplier/add/:id?',
          name: 'addSupplier',
          beforeEnter: (to, from, next) => {
            const hasEditPermission = store.getters.hasPermission('edit')
            if (hasEditPermission) {
              next()
            } else {
              next('/suppliers')
            }
          }
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'addSupplierBank' */ '../views/Supplier/AddSupplierBank'
            ),
          path: '/supplier/bank/add/:sid?/:bid?',
          name: 'addSupplierBank',
          beforeEnter: (to, from, next) => {
            const hasEditPermission = store.getters.hasActionPermission(
              ENTITIES.BANK,
              ACTIONS.CREATE
            )
            if (hasEditPermission) {
              next()
            } else {
              next('/suppliers')
            }
          }
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'transactions' */ '../views/Transactions'
            ),
          path: '/transactions/history',
          name: 'transactions'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'achBankAccounts' */ '../views/AchBankAccounts/index.vue'
            ),
          path: '/transactions/achBankAccounts',
          name: 'achBankAccounts'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'addAchBank' */ '../views/AchBankAccounts/AddAchAccountForm.vue'
            ),
          path: '/achBankAccount/add/:id?',
          name: 'addAchBankAccountForm',
          beforeEnter: (to, from, next) => {
            const hasEditPermission = store.getters.hasPermission('edit')
            if (hasEditPermission) {
              next()
            } else {
              next('/transactions/achBankAccounts')
            }
          }
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'addAchBank' */ '../views/AchBankAccounts/SelectAchAccount.vue'
            ),
          path: '/achBankAccount/selectAcHAccount',
          name: 'selectAchAccount'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'transactions' */ '../views/AccountSummary'
            ),
          path: '/transactions/accountSummary',
          name: 'accountSummary'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'bankHolidays' */ '../views/BankHolidays'
            ),
          path: '/resources/bank-holidays',
          name: 'bankHolidays'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'bankHolidays' */ '../views/Resources/ChargesCalculator'
            ),
          path: '/resources/charges-calculator',
          name: 'chargesCalculator'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'bankInstructions' */ '../views/BankInstructions'
            ),
          path: '/resources/bank-instructions',
          name: 'bankInstructions'
        },
        {
          component: () =>
            import(/* webpackChunkName: 'account' */ '../views/Account'),
          path: '/account',
          name: 'account'
        },
        {
          component: () =>
            import(
              /* webpackChunkName: 'plaidConnection' */ '../views/PlaidConnection'
            ),
          path: '/plaid-connection',
          name: 'plaidConnection'
        }
      ]
    },
    {
      component: () =>
        import(/* webpackChunkName: 'plaidPortal' */ '../views/Plaid'),
      path: '/plaid',
      name: 'plaid'
    },
    {
      path: '/dripSign',
      name: 'dripSign',
      component: () =>
        import(/* webpackChunkName: "ClickWrap" */ '@/views/ClickWrap'),
      meta: {
        auth: true
      }
    }
  ]
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
  if (
    [
      'invoicesAdd',
      'addSupplier',
      'addSupplierBank',
      'addAchBankAccountForm'
    ].includes(from.name) &&
    !to.params.ignoreDialog
  ) {
    const flag = confirm('Changes you made may not be saved')
    if (!flag) {
      return false
    }
  }
  next()
})

export default router
